export default __webpack_public_path__ + "static/media/Vidit.a3e5e2ab.jpg";